import React, { useState } from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@mui/material';
import StyledBox from 'views/rebranded-module/common/components/UI/Faq/Faq.styles';
import { Typography700 } from 'views/rebranded-module/common/components';
import { RiAddLine, RiCloseLine } from 'react-icons/ri';

const Faq = (props) => {
  const { data = [] } = props;
  const [expanded, setExpanded] = useState(data[0]?.id || false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <StyledBox>
      {data.map((item) => (
        <Accordion
          className="FAccordion"
          key={item.id}
          expanded={expanded === item.id}
          onChange={handleChange(item.id)}>
          <AccordionSummary
            className="FAccordionSummary"
            expandIcon={
              expanded === item.id ? (
                <RiCloseLine className="FIcon" />
              ) : (
                <RiAddLine className="FIcon" />
              )
            }>
            <Typography700 variant="body1">{item.question}</Typography700>
          </AccordionSummary>
          <AccordionDetails className="FAccordionDetails">
            <Typography
              variant="body2"
              dangerouslySetInnerHTML={{ __html: item.answer }}
            />
          </AccordionDetails>
        </Accordion>
      ))}
    </StyledBox>
  );
};

export { Faq };
